import { gateNames, useCurrentUser, useGate } from '@mp';
import { MenuItem } from '@medely/web-components';
import React from 'react';
import { SettingsMenuItemsProps } from '../SettingsDropdown';
import { useNavigate } from 'react-router-dom';
import { ReferralContainer } from '@src/components/referrals/ReferralContainer';

export const MarketplaceSettingsMenu = ({ handleClose }: SettingsMenuItemsProps) => {
  const { isDeactivated, isApplicant, isMarketplace } = useCurrentUser();
  const navigate = useNavigate();
  const referralLinkGate = useGate(gateNames.referralLinkGate);
  const showReferralLink = referralLinkGate && !isDeactivated && isMarketplace;

  return (
    <>
      {!isApplicant && (
        <>
          {!isDeactivated && (
            <MenuItem
              onClick={() => {
                navigate('/profile');
                handleClose();
              }}
            >
              My Profile
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
              navigate('/settings');
              handleClose();
            }}
          >
            Settings
          </MenuItem>
        </>
      )}
      {showReferralLink && (
        <MenuItem
          onClick={() => {
            handleClose();
          }}
        >
          <ReferralContainer isPopup />
        </MenuItem>
      )}
    </>
  );
};
